import script from "./ImageGalleryPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGalleryPopup.vue?vue&type=script&setup=true&lang=js"

import "./ImageGalleryPopup.vue?vue&type=style&index=0&id=9773071e&lang=scss"

const __exports__ = script;

export default __exports__